var botnia;
(function($) {
  "use strict";
  botnia = (function() {
    return {
      init: function() {
        this.fixedHeader();
        this.accordion();
        this.productsSlider();
        this.riveAnimations();
        //this.customCursor();
        this.customCursor2();
        this.dropdownMenu();
        this.hoverImage();
        this.homeHeroAnimation();
        this.homePackagingAnimation();
        this.packagingAnimation();
        this.video();
      },
      fixedHeader: function() {
        $(document).scroll(function() {
          if ($(document).scrollTop() > 0) {
            $('header.header').addClass('fixed');
            $('.breadcrumb-container').addClass('fixed');
          } else {
            $('header.header').removeClass('fixed');
            $('.breadcrumb-container').removeClass('fixed');
          }
        });
      },
      accordion: function() {
        $('.accordion h3').click( function(e) {
          e.preventDefault();
          $('.accordion').not( $(this).parent() ).each( function() {
            $(this).find('.accordion-content').slideUp();
            $(this).removeClass('active');
          });
          $(this).parent().find('.accordion-content').slideToggle();
          $(this).parent().toggleClass('active');
          $('.slider-3-items').slick('refresh');
        });
        $('.accordion .toggle-accordion').click( function(e) {
          e.preventDefault();
          $('.accordion').not( $(this).closest('.accordion') ).each( function() {
            $(this).find('.accordion-content').slideUp();
            $(this).removeClass('active');
          });
          $(this).closest('.accordion').find('.accordion-content').slideToggle();
          $(this).closest('.accordion').toggleClass('active');
        });
        setTimeout(function () {
          $("body.index .accordion h3").eq(0).click();
        }, 1000);
      },
      productsSlider: function() {
        $('.slider-3-items').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 767,
              settings: {
                autoplay: true
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
              }
            },
          ]
        });
        $('.slider-2-items').slick({
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: false,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                autoplay: true
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
              }
            },
          ]
        });
        if( $(window).width() < 767 ) { 
          $('.slider-mobile').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: false,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  autoplay: true
                }
              }
            ]
          });
        }
      },
      riveAnimations: function() {
        if( $('#hero-canvas').length ) {
          const r1 = new rive.Rive({
            src: "assets/animations/hero.riv",
            canvas: document.getElementById("hero-canvas"),
            autoplay: true,
          });
        }
      },
      customCursor: function() {
        let circle = document.getElementById('cursor');
        const onMouseMove = (e) =>{
          console.log(e);
          circle.style.left = e.pageX + 'px';
          circle.style.top = e.pageY + 'px';
        }
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener("onscroll", onMouseMove);
        $('.slick-slider').hover( function() {
          $('#cursor').addClass('draggable');
        }, function() {
          $('#cursor').removeClass('draggable');
        })
      },
      customCursor2: function() {
        const lerp = (a, b, n) => (1 - n) * a + n * b;

        class Cursor {
          constructor() {
            // config
            this.target = { x: 0.5, y: 0.5 }; // mouse position
            this.cursor = { x: 0.5, y: 0.5 }; // cursor position
            this.speed = 1;
            this.init();
          }
          bindAll() {
            ["onMouseMove", "render"].forEach((fn) => (this[fn] = this[fn].bind(this)));
          }
          onMouseMove(e) {
            //get normalized mouse coordinates [0, 1]
            this.target.x = e.clientX / window.innerWidth;
            this.target.y = e.clientY / window.innerHeight;
            // trigger loop if no loop is active
            if (!this.raf) this.raf = requestAnimationFrame(this.render);
          }
          render() {
            //calculate lerped values
            this.cursor.x = lerp(this.cursor.x, this.target.x, this.speed);
            this.cursor.y = lerp(this.cursor.y, this.target.y, this.speed);
            document.documentElement.style.setProperty("--cursor-x", this.cursor.x);
            document.documentElement.style.setProperty("--cursor-y", this.cursor.y);
            //cancel loop if mouse stops moving
            const delta = Math.sqrt(
              Math.pow(this.target.x - this.cursor.x, 2) +
              Math.pow(this.target.y - this.cursor.y, 2)
            );
            if (delta < 0.001) {
              cancelAnimationFrame(this.raf);
              this.raf = null;
              return;
            }
            //or continue looping if mouse is moving
            this.raf = requestAnimationFrame(this.render);
          }
          init() {
            this.bindAll();
            window.addEventListener("mousemove", this.onMouseMove);
            this.raf = requestAnimationFrame(this.render);
          }
        }
        $('.slick-slider').hover( function() {
          $('#cursor').addClass('draggable');
        }, function() {
          $('#cursor').removeClass('draggable');
        })
        new Cursor();
      },
      dropdownMenu: function() {
        $('._show-menu-dropdown-menu').click( function(e) {
          e.preventDefault();
          $('._show-menu-dropdown-shop, ._show-menu-dropdown-gift, ._show-menu-dropdown-track, ._show-menu-dropdown-account, ._show-menu-dropdown-search, ._show-cart, .menu-cart').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-shop, .menu-dropdown-gift, .menu-dropdown-track, .menu-dropdown-account, .menu-dropdown-search').slideUp();
          $(this).find('.icon-hamburger').toggleClass('active');
          $('.menu-dropdown-menu').slideToggle( function() {
            if( $('.menu-dropdown-menu').css('display') == 'block' ) {
              $('.menu-dropdown-bg').fadeIn();
            } else {
              $('.menu-dropdown-bg').fadeOut();
            }
          });
        });
        $('._show-menu-dropdown-shop').click( function(e) {
          e.preventDefault();
          $('._show-menu-dropdown-menu, ._show-menu-dropdown-gift, ._show-menu-dropdown-track, ._show-menu-dropdown-account, ._show-menu-dropdown-search, ._show-cart, .menu-cart, .icon-hamburger').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-gift, .menu-dropdown-menu, .menu-dropdown-track, .menu-dropdown-account, .menu-dropdown-search').slideUp();
          $(this).toggleClass('opacity-30');
          $('.menu-dropdown-shop').slideToggle(function() {
            if( $('.menu-dropdown-shop').css('display') == 'block' ) {
              $('.menu-dropdown-bg').fadeIn();
            } else {
              $('.menu-dropdown-bg').fadeOut();
            }
          });
        });
        $('._show-menu-dropdown-gift').click( function(e) {
          e.preventDefault();
          $('._show-menu-dropdown-menu, ._show-menu-dropdown-shop, ._show-menu-dropdown-track, ._show-menu-dropdown-account, ._show-menu-dropdown-search, ._show-cart, .menu-cart, .icon-hamburger').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-shop, .menu-dropdown-menu, .menu-dropdown-track, .menu-dropdown-account, .menu-dropdown-search').slideUp();
          $(this).toggleClass('opacity-30');
          $('.menu-dropdown-gift').slideToggle(function() {
            if( $('.menu-dropdown-gift').css('display') == 'block' ) {
              $('.menu-dropdown-bg').fadeIn();
            } else {
              $('.menu-dropdown-bg').fadeOut();
            }
          });
        });
        $('._show-menu-dropdown-track').click( function(e) {
          e.preventDefault();
          $('._show-menu-dropdown-menu, ._show-menu-dropdown-shop, ._show-menu-dropdown-gift, ._show-menu-dropdown-account, ._show-menu-dropdown-search, ._show-cart, .menu-cart, .icon-hamburger').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-menu, .menu-dropdown-shop, .menu-dropdown-gift, .menu-dropdown-account, .menu-dropdown-search').slideUp();
          $(this).toggleClass('opacity-30');
          $('.menu-dropdown-track').slideToggle(function() {
            if( $('.menu-dropdown-track').css('display') == 'block' ) {
              $('.menu-dropdown-bg').fadeIn();
            } else {
              $('.menu-dropdown-bg').fadeOut();
            }
          });
        });
        $('._show-menu-dropdown-account').click( function(e) {
          e.preventDefault();
          $('._show-menu-dropdown-menu, ._show-menu-dropdown-shop, ._show-menu-dropdown-gift, ._show-menu-dropdown-track, ._show-menu-dropdown-search, ._show-cart, .menu-cart, .icon-hamburger').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-menu, .menu-dropdown-shop, .menu-dropdown-gift, .menu-dropdown-track, .menu-dropdown-search').slideUp();
          $(this).toggleClass('opacity-30');
          $('.menu-dropdown-account').slideToggle(function() {
            if( $('.menu-dropdown-account').css('display') == 'block' ) {
              $('.menu-dropdown-bg').fadeIn();
            } else {
              $('.menu-dropdown-bg').fadeOut();
            }
          });
        });
        $('._show-menu-dropdown-search').click( function(e) {
          e.preventDefault();
          $('._show-menu-dropdown-menu, ._show-menu-dropdown-shop, ._show-menu-dropdown-gift, ._show-menu-dropdown-track, ._show-menu-dropdown-account, ._show-cart, .menu-cart, .icon-hamburger').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-menu, .menu-dropdown-shop, .menu-dropdown-gift, .menu-dropdown-track, .menu-dropdown-account').slideUp();
          $(this).toggleClass('opacity-30');
          $('.menu-dropdown-search').slideToggle(function() {
            if( $('.menu-dropdown-search').css('display') == 'block' ) {
              $('.menu-dropdown-bg').fadeIn();
            } else {
              $('.menu-dropdown-bg').fadeOut();
            }
          });
        });
        $('._show-cart').click( function(e) {
          e.preventDefault();
          $('._show-menu-dropdown-menu, ._show-menu-dropdown-shop, ._show-menu-dropdown-gift, ._show-menu-dropdown-track, ._show-menu-dropdown-account, .icon-hamburger').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-menu, .menu-dropdown-shop, .menu-dropdown-gift, .menu-dropdown-track, .menu-dropdown-account, .menu-dropdown-search').slideUp();
          $(this).toggleClass('opacity-30');
          $('.menu-cart').toggleClass('active');
          if( $('.menu-cart').hasClass('active') ) {
            $('.menu-dropdown-bg').fadeIn();
          } else {
            $('.menu-dropdown-bg').fadeOut();
          }
        });
        $('.menu-dropdown-bg').click( function(e) {
          $('._show-menu-dropdown-menu, ._show-menu-dropdown-shop, ._show-menu-dropdown-gift, ._show-menu-dropdown-track, ._show-menu-dropdown-account, ._show-cart, .menu-cart, .icon-hamburger').removeClass('opacity-30').removeClass('active');
          $('.menu-dropdown-menu, .menu-dropdown-shop, .menu-dropdown-gift, .menu-dropdown-track, .menu-dropdown-account, .menu-dropdown-search').slideUp();
          $('.menu-dropdown-bg').fadeOut();
        });
      },
      hoverImage: function() {
        if($(window).outerWidth() > 767) {
          $('img[hover-src]').hover( function() {
            var firstSrc = $(this).attr('src');
            var secondSrc = $(this).attr('hover-src');
            $(this).attr('src', secondSrc);
            $(this).attr('hover-src', firstSrc);
          }, function() {
            var firstSrc = $(this).attr('src');
            var secondSrc = $(this).attr('hover-src');
            $(this).attr('src', secondSrc);
            $(this).attr('hover-src', firstSrc);
          });
        } 
      },
      homeHeroAnimation: function() {
        if( $('.with-hero').length ) {
          $(document).scroll(function() {
            var st = $(document).scrollTop();
              var opacityText = st/150;
              if( opacityText > 1 ) {
                opacityText = 1;
              }
              var opacityVideo = 1 - st/150;
              if( opacityVideo < 0.3 ) {
                opacityVideo = 0.3;
              }
              var transformVideo = 1 - st/300;
              if( transformVideo < 0.8 ) {
                transformVideo = 0.8;
              }
              $('.with-hero .hero').css('opacity', opacityText);
              $('.with-hero .js-video, .with-hero img').css('opacity', opacityVideo).css('transform', 'scale('+transformVideo+')');
          });
          $(".with-hero .btn").click(function () {
            if ($(this).find('span').text().toLowerCase().includes('shop gift guide')) {
              $('html, body').animate({
                scrollTop: $('body.index .accordion').eq(0).offset().top - 150
              }, 1000); 
              return false;
            }
          });
        }
      },
      homePackagingAnimation: function() {
        if( $('.packaging-animation-container').length ) {
          $(document).scroll(function() {
              var offset1 = $(document).scrollTop() - $('.packaging-animation-container').position().top + 50;
              if( offset1 < 0 ) {
                offset1 = 0;
              }
              var offset2 = offset1*1.5;
              $('.packaging-animation-container .package .p1').css('transform', 'translateY('+offset1+'px)');
              $('.packaging-animation-container .package .p3').css('transform', 'translateY('+offset2+'px)');
          });
        }
      },
      packagingAnimation: function() {
        if( $('.packaging-animation').length ) {
          var sectionHeight = $('.packaging-animation').height();
          $(document).scroll(function() {
              var offset1 = $(document).scrollTop() - $('.packaging-animation').position().top;
              if( offset1 < 0 ) {
                offset1 = 0;
              }
              if( offset1 < sectionHeight / 6 ) {
                $('.packaging-animation .images').attr('slide', 1);
              }
              if( offset1 >= sectionHeight / 6 && offset1 < sectionHeight / 6 * 2) {
                $('.packaging-animation .images').attr('slide', 2);
              }
              if( offset1 >= sectionHeight / 6 * 2 && offset1 < sectionHeight / 6 * 3) {
                $('.packaging-animation .images').attr('slide', 3);
              }
              if( offset1 >= sectionHeight / 6 * 3 && offset1 < sectionHeight / 6 * 4) {
                $('.packaging-animation .images').attr('slide', 4);
              }
              if( offset1 >= sectionHeight / 6 * 4) {
                $('.packaging-animation .images').attr('slide', 5);
              }
          });
        }
      },
      video: function() {
        if($('.js-video').length > 0) {
          $(".js-video").each(function () {
            this.controls = false;
            $(this).get(0).play();
            $(this).addClass("active");
          });
        }
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  botnia.init();
});